import { jsx as d } from "react/jsx-runtime";
import { forwardRef as r } from "react";
import s from "@mui/material/CardContent";
import i from "styled-components";
const C = {
  root: "cardContentRoot"
}, f = i(s).withConfig({
  displayName: "StyledCardContent"
})([
  "&&.cardContentRoot{font-size:",
  ";",
  ";}"
], ({ theme: t }) => t.typography.body100.fontSize, ({ $disablePadding: t }) => t ? "padding: 0px" : ""), l = /* @__PURE__ */ r(({ children: t, classes: o, disablePadding: a = !1, ...e }, n) => /* @__PURE__ */ d(f, {
  ...e,
  ref: n,
  classes: {
    ...C,
    ...o
  },
  $disablePadding: a,
  children: t
}));
l.displayName = "CardContent";
export {
  l as default
};
